import React from 'react';
import SharePointEmbed from './SharePointEmbed';

export default function SharePointVideoPlayer({ spEmbedUrl, title }) {
  // Only use SharePoint embed iframe - no fallbacks needed for public videos
  if (spEmbedUrl) {
    return (
      <div className="sp-player-embed">
        <SharePointEmbed
          src={spEmbedUrl}
          title={title || "Course recording"}
        />
      </div>
    );
  }

  return (
    <div style={{
      padding: "2rem",
      textAlign: "center",
      color: "var(--text-muted)",
      backgroundColor: "var(--background-secondary)",
      borderRadius: 0,
      border: "1px solid var(--border-color)"
    }}>
      <div style={{ fontSize: "1.1rem", marginBottom: "0.5rem" }}>📹</div>
      <div>Video link unavailable</div>
      <div style={{ fontSize: "0.9rem", marginTop: "0.5rem" }}>
        No SharePoint embed URL provided
      </div>
    </div>
  );
}
